import { render, staticRenderFns } from "./organize_edit_form.vue?vue&type=template&id=f8f43e6c&scoped=true&"
import script from "./organize_edit_form.vue?vue&type=script&lang=js&"
export * from "./organize_edit_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f43e6c",
  null
  
)

export default component.exports